<template>
  <div>
    <v-card class="soft-card stat-card pa-4">
        <v-layout row justify-space-between align-start>
            <div>
                <div class="stat-label">{{ card.label }}</div>
                <div class="stat-value">
                    <template v-if="card.value === null || card.value === undefined">—</template>
                    <template v-else-if="card.currency">{{ card.value | currency }}</template>
                    <template v-else>{{ card.value }}</template>
                </div>
            </div>
            <div style="display: flex;">
                <div class="stat-delta" v-if="card.delta" :style="{ color: card.positive ? '#047857' : '#be123c' }">
                    <v-icon small :color="card.positive ? 'green darken-2' : 'red darken-2'">{{ card.positive ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                        {{ card.delta }}
                </div>
                <div :class="['icon-box', card.tone + '-soft']">
                    <v-icon>{{ card.icon }}</v-icon>
                </div>
            </div>
        </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['card'],
  data() {
    return {
      
    };
  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
